import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Supplier, SupplierAccessSave } from '../models/supplier.model';

export const SupplierActions = createActionGroup({
  source: 'Supplier Access',
  events: {
    'Load Suppliers': props<{ buyerId: number }>(),
    'Load Suppliers Success': props<{ suppliers: Supplier[] }>(),
    'Load Suppliers Failure': props<{ error: string }>(),
    'Update Supplier': props<{ id: number; data: Partial<Supplier> }>(),
    'Save Supplier Access': props<SupplierAccessSave>(),
    'Save Supplier Access Success': emptyProps(),
    'Save Supplier Access Failure': props<{ error: string }>(),
  },
});
